<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          border
          clickable
          :readonly="isReadonly"
          size="small"
          placeholder="请选择部门"
          @click="showPicker = true"
          @focus="isReadonly = true"
          @blur="isReadonly = false"
          v-model="search.department"
          is-link
          arrow-direction="down"
          clearable
          clear-trigger="always"
        />
        <van-field
          size="small"
          v-model="code"
          placeholder="采购单号/提货单号"
          :formatter="relationNumberFmt"
          @keyup.13="getList('search')"
        />
        <van-field
          size="small"
          v-model="search.skuCode"
          placeholder="SKU"
          right-icon="scan"
          @click-right-icon="scan"
          @keyup.13="getList('search')"
        />
      </div>

      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList('search')">查询</button>
      </div>
    </div>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            ref="vList"
            @load="onLoad"
          >
            <ul>
              <li
                @click="toPutawayDetail(item)"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="sign-list">
                  <p>采购单号：{{ item.relationNumber }}</p>
                  <p>到仓日期：{{ item.signForTime }}</p>
                </div>
                <div class="sign-list">
                  <p>提货单：{{ item.trackNumber }}</p>
                  <p>收货单：{{ item.putOnNo }}</p>
                </div>
                <div class="sign-list">
                  <p>SKU：{{ item.skuCode }}</p>
                  <p>件数/数量：{{ item.totalBoxCount }}/{{ item.totalQty }}</p>
                </div>
                <div class="sign-list">
                  <p>类型：{{ item.sourceTypeIDDesc }}</p>
                  <p>签收人：{{ item.signForUser }}</p>
                </div>
              </li>
            </ul>
          </van-list>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>

    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      @close="pickerClose"
    >
      <van-picker
        show-toolbar
        cancel-button-text="关闭"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        @change="onItemChange"
        ref="departmentPicker"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Empty,
  List,
  PullRefresh,
  cell,
  Toast,
  Loading,
} from "vant";
import { getDepartmentList } from "@/api/mobile/signIn_api";
import { getPutOnList } from "@/api/mobile/putaway_api";
import { mapState } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      showPicker: false,
      columns: [],
      departmentList: [],

      list: [],
      loading: false,
      finished: false,
      startSearch: false,
      code: "",
      search: {
        page: 1,
        pageSize: 10,
        relationNumber: "",
        trackNumber: "",
        department: "",
        skuCode: "",
        warehouseId: "",
      },
      isReadonly: false,
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [cell.name]: cell,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field,
  },
  mixins: [mixins],
  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      this.$set(this.search, "warehouseId", _warehouse.warehouseId);

      this.getDepartment();
    },
    pickerClose() {
      this.$refs.departmentPicker.confirm();
    },
    onConfirm(val) {
      this.$set(this.search, "department", val);
      this.showPicker = false;
    },
    onItemChange(e, value, index) {
      function fn() {
        const that = this;
        this.$set(this.search, "department", value);
        that.showPicker = false;
      }
      debounce(fn.apply(this), 300);
    },
    scan() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          Toast("调用成功");
          that.$set(that.search, "skuCode", a.resultStr);
        },
        error: function (res) {
          alert("调用失败--", res);
        },
      });
    },
    toPutawayDetail(item) {
      const { putOnNo, skuCode } = item;
      this.$router.push({
        path: "/mobile/putawayDetail",
        query: { putOnNo, skuCode },
      });
    },
    getList(type) {
      if (type === "search") {
        this.list = [];
        this.finished = false;
        this.search.page = 1;
      }

      if (this.code.includes("CG")) {
        this.$set(this.search, "relationNumber", this.code);
        this.$set(this.search, "trackNumber", "");
      } else {
        this.$set(this.search, "relationNumber", "");
        this.$set(this.search, "trackNumber", this.code);
      }

      if (this.search.page === 1) {
        this.startSearch = true;
      }

      getPutOnList(this.search).then((res) => {
        this.startSearch = false;
        this.loading = false;
        if (res.status === 200) {
          const { pageData, pageCount, pageIndex } = res.response;

          if (pageCount === pageIndex) {
            this.finished = true;
          }

          if (!pageData.length) Toast("暂无匹配数据");

          try {
            pageData.forEach((row) => {
              row.signForTime = util.formatDate.format(
                new Date(row.signForTime),
                "yyyy-MM-dd"
              );
            });
          } catch {}

          this.list.push(...pageData);
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    getDepartment() {
      const user = window.localStorage.user
        ? JSON.parse(window.localStorage.user)
        : null;
      const data = {
        orgID: user.organizationId || "",
      };

      getDepartmentList(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          this.departmentList = response;

          let arr = [];
          response.forEach((item) => {
            arr.push(item.departmentName);
          });
          this.columns = arr;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    onLoad() {
      this.search.page++;

      this.getList();
    },
    relationNumberFmt(v) {
      return v.trim();
    },
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {
        if (newValue.path === "/mobile/mobileMenu") {
          this.list = [];
          this.$set(this.search, "page", 1);
          this.$set(this.search, "pageSize", 10);
          this.$set(this.search, "department", "");
          this.$set(this.search, "relationNumber", "");
          this.$set(this.search, "trackNumber", "");
          this.$set(this.search, "skuCode", "");
        }
        if (newValue.path === "/mobile/putaway") {
          debugger;
          this.code = "";
          if (
            this.search.department ||
            this.search.skuCode ||
            this.search.trackNumber
          ) {
            this.getList("search");
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.sign {
  background-color: #fbf9fe;
}
.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}
.sign-search .btn-box {
  flex: 0.6;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 120px;
}
.sign-toSearch {
  width: 100%;
  height: 94%;
  min-height: 120px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}
.toSearch-box {
  vertical-align: top;
}
.sign-item {
  border-top: 1px solid #ccc;
}
.sign-item li {
  border-bottom: 1px solid #ccc;
  background-color: #fbf9fe;
  padding: 3px 10px;
  font-size: 12px;
}
.sign-list {
  display: flex;
  p {
    flex: 1;
    word-break: break-all;
    margin: 5px 0;
  }
}
</style>